import { Availability, AvailabilityId } from '@domains/product';

export type MappedAvailability = Availability & {
    buttonText: string;
    isDisabledButton: boolean;
    isDisabledFavorite: boolean;
};

export const useProductAvailability = (availability: Availability): MappedAvailability => {
    switch (availability.id) {
        case AvailabilityId.InStock: {
            return {
                ...availability,
                buttonText: 'В корзину',
                isDisabledButton: false,
                isDisabledFavorite: false,
            };
        }
        case AvailabilityId.onTheWay: {
            return {
                ...availability,
                buttonText: 'Товар в\u00a0пути',
                isDisabledButton: true,
                isDisabledFavorite: false,
            };
        }
        case AvailabilityId.outOfStock:
        default: {
            return {
                ...availability,
                buttonText: 'Нет в\u00a0наличии',
                isDisabledButton: true,
                isDisabledFavorite: true,
            };
        }
    }
};
